module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 158.f2804186.png";